import { WarningOutlined } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'

export function NoRouteData() {
  return (
    <Horizontal
      height={'auto'}
      gap={8}
      style={{
        position: 'absolute',
        top: '1em',
        right: '1em',
        zIndex: 1000,
        backgroundColor: 'var(--bg-1)',
        boxShadow: '0 2px 2px rgba(60,64,67,0.3),0 1px 3px 1px rgba(60,64,67,0.15)',
      }}
      borderRadius={4}
      className='px-2 py-1'
    >
      <Texto category='h5'>
        <WarningOutlined style={{ color: 'var(--theme-warning)' }} className='mr-2' />
        No route data available
      </Texto>
    </Horizontal>
  )
}
